module.exports = __webpack_public_path__ + "static/media/Artboard2.d1d7d699.png";